import { request } from '../api';

/** Mirrors the views of `apps/api/src/dialogs/*` (ADR-0007). */

export const DIALOG_TOOLS = ['claude_code', 'cowork', 'claude_ai'] as const;
export type DialogTool = (typeof DIALOG_TOOLS)[number];
export type DialogStatus = 'working' | 'waiting_human' | 'done';
/** Chip values: the stored statuses plus the derived "stale". */
export type DialogFilter = DialogStatus | 'stale';

export interface DialogRow {
  id: string;
  tool: DialogTool;
  externalId: string;
  title: string;
  cwd: string | null;
  url: string | null;
  status: DialogStatus;
  stale: boolean;
  business: { id: string; name: string } | null;
  project: { id: string; name: string } | null;
  startedAt: string;
  lastActivityAt: string;
  endedAt: string | null;
  openQuestions: number;
}

export interface DialogDetail extends DialogRow {
  lastMessage: string | null;
  panelUrl: string;
  tasks: Array<{ id: string; key: string; title: string; status: string }>;
}

export interface DialogListResult {
  rows: DialogRow[];
  total: number;
  page: number;
  pageSize: number;
  counts: Record<DialogFilter, number>;
}

export interface DialogListParams {
  status?: DialogFilter;
  tool?: DialogTool;
  businessId?: string;
  page: number;
  pageSize: number;
}

export const dialogsApi = {
  list(p: DialogListParams): Promise<DialogListResult> {
    const q = new URLSearchParams({ page: String(p.page), pageSize: String(p.pageSize) });
    if (p.status) q.set('status', p.status);
    if (p.tool) q.set('tool', p.tool);
    if (p.businessId) q.set('businessId', p.businessId);
    return request(`/dialogs?${q}`);
  },
  get: (id: string): Promise<DialogDetail> => request(`/dialogs/${encodeURIComponent(id)}`),
};
